export const DSTPartTimeDepartmentId = "6e2f4d6f-5032-4a95-9bc2-64c5af317555";